<template>
  <v-col v-if="isRepriseSession" cols="12" class="pt-0">
    <v-row no-gutters>
      <v-col v-if="!loading" cols="12">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Produits *</v-list-item-subtitle>
            <v-list-item-title>
              <v-row no-gutters>
                <v-col class="d-flex align-center">
                  <v-sheet style="overflow-x: hidden;">
                    <v-chip-group show-arrows>
                      <v-chip
                        v-for="(pa ,i) in ProductActivityLabel"
                        :key="i"
                        close
                        @click:close="deleteProduct(i)"
                      >
                        {{ pa }}
                      </v-chip>
                    </v-chip-group>
                  </v-sheet>
                  <v-btn
                    icon
                    :class="{'mt-2':!ProductActivityLabel.length}"
                    color="grey darken-1"
                    @click="openSelectorModal()"
                  >
                    <v-icon>mdi-plus-circle-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col v-else cols="12">
        <div class="d-flex justify-center align-center full-height flex-column">
          <span class="mb-4">obtenir des produits</span>
          <Loader />
        </div>
      </v-col>
    </v-row>
    <ProductActivityModal v-if="productActivityDialog" />
  </v-col>
</template>

<script>
import { inject, computed, onBeforeMount, ref } from '@vue/composition-api';
import { repriseSessionType, sendNotification } from '@/helpers/utils';

import ProductActivityModal from '@/components/common/ProductActivityModal.vue';
import Loader from '@/components/common/Loader.vue';

import store from '@/store';

export default {
  components: { ProductActivityModal, Loader },
  setup () {
    const newSession = inject('newSession');
    const productActivityDialog = inject('productActivityDialog');
    const loading = ref(false);

    const isRepriseSession = computed(() => repriseSessionType.includes(newSession.value.type));

    const ProductActivityLabel = computed(() => newSession.value.product_activity.map(pa => {
      const foundproduct = (store.state.products || []).find(p => p.uuid === pa.product);
      if (foundproduct) {
        const foundActivity = foundproduct.activities.find(a => a.uuid === pa.activity);
        return `${foundproduct.wtitle} + ${foundActivity ? foundActivity.activity_name : ''}`;
      }
      return null;
    }).filter(p => p));

    const deleteProduct = index => {
      newSession.value.product_activity.splice(index, 1);
      sendNotification('success', 'Produit supprimé avec succès');
    };

    const openSelectorModal = () => {
      productActivityDialog.value = true;
    };

    onBeforeMount(async () => {
      if (!store.state.isLazyLoaded.products) {
        loading.value = true;
        await store.dispatch('getProducts');
        loading.value = false;
      }
    });

    return { productActivityDialog, isRepriseSession, ProductActivityLabel, deleteProduct, openSelectorModal, loading };
  }
};

</script>
